/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={enableCache:!1};export{e as shaderTranspiler};
